module.exports = __webpack_public_path__ + "static/media/icon-feather-trash.2a1b6536.svg";